import { useMemo } from "react";
import * as SeparatorPrimitive from "@radix-ui/react-separator";
import clsx from "clsx";

export type DividerV2Props = SeparatorPrimitive.SeparatorProps;

export function DividerV2({
  orientation = "horizontal",
  decorative = true,
  className: classNameProps,
}: DividerV2Props) {
  const classNames = useMemo(() => (orientation === "vertical" ? "w-px min-h-full" : "h-px min-w-full"), [orientation]);
  return (
    <SeparatorPrimitive.Root
      className={clsx("bg-neutral-300", classNames, classNameProps)}
      orientation={orientation}
      decorative={decorative}
    />
  );
}

export default DividerV2;
